module.exports = __webpack_public_path__ + "files/4aa3a9c6312611fd26537f7dcb207cb1.svg";